import { BusinessShippingRate } from '@/models/businesses/business-shipping-rate';
import { axiosService } from '.';

export default class BusinessesShippingRatesService {
    public async newBusinessShippingRate(businessId: number, businessShippingRate: BusinessShippingRate): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/shipping-rates/${businessId}/new`, businessShippingRate)).data;
    }

    public async getBusinessShippingRates(businessId: number): Promise<BusinessShippingRate[]> {
        const response = await axiosService.instance.get(`businesses/organization/shipping-rates/${businessId}`);
        return response.data.map((shippingRate: any) => new BusinessShippingRate(shippingRate));
    }

    public async getBusinessShippingRate(businessId: number, businessShippingRateId: number): Promise<BusinessShippingRate> {
        return new BusinessShippingRate((await axiosService.instance.get(`businesses/organization/shipping-rates/${businessId}/${businessShippingRateId}`)).data);
    }

    public async updateBusinessShippingRate(businessId: number, businessShippingRate: BusinessShippingRate): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/shipping-rates/${businessId}/update`, businessShippingRate)).data;
    }

    public async deleteBusinessShippingRate(businessId: number, businessShippingRateId: number): Promise<boolean> {
        return (await axiosService.instance.post(`businesses/organization/shipping-rates/${businessId}/disable?businessShippingRateId=${businessShippingRateId}`)).data;
    }
}

export const businessesShippingRatesService = new BusinessesShippingRatesService();
